import React from "react";

interface StatusBadgeProps {
    status: {
        status: string;
        color: string;
    };
    size?: "small" | "medium" | "large";
    className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
    status,
    size = "medium",
    className = "",
}) => {
    const sizeClasses = {
        small: "px-2 py-0.5 text-xs",
        medium: "px-3 py-1 text-sm",
        large: "px-4 py-2 text-base",
    };

    return (
        <span
            className={`inline-flex items-center justify-center rounded-full font-semibold shadow-sm transition-all duration-200 ${sizeClasses[size]} ${className}`}
            style={{
                backgroundColor: status?.color || "#e0e0e0",
                color: getContrastColor(status?.color || "#e0e0e0"),
            }}
        >
            {status?.status || "Unknown"}
        </span>
    );
};

// Helper function to determine text color based on background
function getContrastColor(hexColor: string): string {
    // Remove # if present
    const hex = hexColor.replace("#", "");

    // Convert to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

    // Return black or white based on luminance
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
}

